import React from 'react';
import { observer } from "mobx-react";
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { cartInstance } from 'ReactApp/Ddd/Aggregates/Cart';
import {ShowableProductCardHtmlIdentifierEnum} from "../../Types/enum";

type BuyBtnV1Props = {
    productCard: ShowableProductCard
}

const BuyBtnV1 = observer((props: BuyBtnV1Props) => {

    let {currentProductConfig} = props.productCard;

    const toCartAdditionalProducts = ()=> {
        const additionalProductsWrap = document.getElementById(
            ShowableProductCardHtmlIdentifierEnum.additionalProductsWrapId
        );
        if(additionalProductsWrap === null) {
            return null;
        }
        const checkboxes = additionalProductsWrap.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {

                const productTypeIdAttr = checkbox.getAttribute('data-product-type-id');
                if (productTypeIdAttr === null) {
                    return
                }
                const productTypeIdEnum =
                    props.productCard.convertStringToProductTypeEnum(productTypeIdAttr);

                const productIdAttr = checkbox.getAttribute('data-product-id');
                if (productTypeIdEnum !== null && productIdAttr !== null) {

                    let result = cartInstance.addOrChange(
                        productTypeIdEnum,
                        parseInt(productIdAttr),
                        1,
                        undefined
                    );

                    cartInstance.updateAll();
                }
            }
        });
    }

    const toCartHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        let config = props.productCard.currentProductConfig;
        if (config === null || config.isInCart === true) {
            return;
        }
        if (cartInstance.productSet !== null) {
            let result = cartInstance.addOrChange(
                config.productTypeId,
                config.id,
                config.count,
                (config.virtualModifierId !== null)
                    ? config.virtualModifierId
                    : undefined
            );
            if (result === true) {
                props.productCard.toCart();
            }

            toCartAdditionalProducts();
            cartInstance.updateAll();
        }
    }

    let buyButtonClasses: string[] = [
        'button-v1',
        'button-v1_text-color-type-white',
        'button-v1_filling-color-type-main',
        'button-v1_filling-type-contained',
    ];

    if (currentProductConfig?.isInCart === true) {
        buyButtonClasses.push('button-v1_disabled');
    }

    return (
        <a
            className={buyButtonClasses.join(' ')}
            href="#"
            onClick={toCartHandler}
            add-to-cart-v1=""
            data-add-to-cart-v1-is-in-cart={currentProductConfig?.isInCart === true ? '1' : '0'}
            data-add-to-cart-v1-count={currentProductConfig?.count}
            data-add-to-cart-v1-product-type-id={currentProductConfig?.productTypeId}
            data-add-to-cart-v1-id={currentProductConfig?.id}
            data-add-to-cart-v1-virtual-modifier-id={currentProductConfig?.virtualModifierId}
            data-add-to-cart-v1-in-label="Купить"
            data-add-to-cart-v1-out-label="В корзине"
        >
            {
                (props.productCard.currentProductConfig?.isInCart === true)
                    ? 'В корзине'
                    : 'Купить'
            }
        </a>
    );
});

export { BuyBtnV1 };